<template>

<b-modal v-model="modalShow"
         centered
         :title="$t('labels.createCurrency')"
         hide-footer>

    <b-overlay :show="loadingData" variant="transparent" no-wrap />
 
   <validation-observer ref="simpleRules">
      <b-form>
        <b-row>

          <b-col md="12">
            <b-form-group :label="$t('labels.name')">
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >
                <b-form-input
                  v-model="formData.name"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('labels.abbreviation')">
              <validation-provider
                #default="{ errors }"
                name="abbreviation"
                rules="required"
              >
                <b-form-input
                  v-model="formData.abbreviation"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.abbreviation')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('labels.description')">
              <validation-provider
                #default="{ errors }"
                name="description"
                rules="required"
              >
                <b-form-input
                  v-model="formData.description"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.description')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('labels.symbol')">
              <validation-provider
                #default="{ errors }"
                name="symbol"
                rules="required"
              >
                <b-form-input
                  v-model="formData.symbol"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.symbol')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationForm"
            >
              {{$t('buttons.submit')}}
            </b-button>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>

</b-modal>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BCardText, VBModal, BCard, BOverlay
} from 'bootstrap-vue'
import { required, integer } from '@validations'
import { mapActions  } from 'vuex'
import { BFormCheckbox } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BCard,
    vSelect,
    VBModal,
    BOverlay,
    ToastificationContent
  },

  directives: {
    'b-modal': VBModal,
    Ripple,
  },

  data() {
    return {
        modalShow: false,
      formData: {
        name: null,
        description: null,
        abbreviation: null,
        symbol: null,
      },
      required,
      integer,
      loadingData: false
    }
  },

  methods: {
      ...mapActions("currency", ["store", "currencys"]),

    async validationForm() {
      this.$refs.simpleRules.validate()
      .then(async (success) => {
        if (success) {
          try {
            this.loadingData = true

             await this.store(this.formData)

             this.resetFormData()
             this.$toast({
               component: ToastificationContent,
                props: {
                  title: this.$t('labels.currencyAdded'),
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
              this.currencys()
             this.modalShow = false

          } catch (error) {

            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('labels.errorAddingCurrency'),
                icon: "AlertTriangleIcon",
                variant: "danger",
                text: `${error.message}`,
              },
            });

          }finally{
            this.loadingData = false
          }   
        }
      })
      .catch((error) => {

        this.$swal({
          title: this.$t('labels.error'),
          text: error.message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })

      })
    },

    resetFormData(){
      this.formData = {
        name: null,
        description: null,
        abbreviation: null,
        symbol: null,
      }
    },

  },
}
</script>
